
import { Sale } from "@/models/base";
import { SaleService } from "@/services";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			computedFriendlyId: "",
			friendlyId: 0
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	watch: {
		sale: {
			immediate: true,
			handler(){
				this.computedFriendlyId = this.sale.ComputedFriendlyID;
				this.friendlyId = this.sale.FriendlyID;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			let sale = await SaleService.changeComputedFriendlyID(this.sale, this.computedFriendlyId, this.friendlyId);
			this.sale.ComputedFriendlyID = sale.ComputedFriendlyID;
			this.sale.FriendlyID = sale.FriendlyID;
			this.close();
		}
	}
});
